import { theme } from './theme.js';
import { hasOwnPropertyAlt } from '@contra/utilities/hasOwnPropertyAlt';

export type Theme = typeof theme;

export type ThemeColorsV2 = keyof Theme['colorsV2'];

export const isThemeColor = (
  color: unknown,
): color is keyof Theme['colors'] => {
  return typeof color === 'string' && hasOwnPropertyAlt(theme.colors, color);
};

export { FLEX, LAYOUT } from './constants.js';
